var React = require('react');

function IconClubhouse (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"nonzero"},React.createElement("path",{"d":"M20.9 183.3C9.4 183.3 0 192.7 0 204.2c0 11.5 9.4 20.9 20.9 20.9 11.5 0 20.9-9.4 20.9-20.9 0-11.5-9.3-20.9-20.9-20.9zM278.2.8l-131.6 42V1.3L4.7 46.6v120.3l122.4-39.1v41.3L288 117.8l-43.6-42.6L278.2.8zM127.1 107.2L24.3 140V60.9l102.8-32.8v79.1zm124.5 1.7l-105 33.5v-79l96.7-30.9-22.2 46.8 30.5 29.6z"})));
}

IconClubhouse.defaultProps = {"width":"288","height":"226"};

module.exports = IconClubhouse;

IconClubhouse.default = IconClubhouse;
